<template lang="pug">
  .table-responsive
    table#tbitemsIn.table.is-striped.is-fullwidth
      thead
        tr
          th Fecha Reg.
          th Origen / Destino
          th Movimiento
          th Cantidad&nbsp
            span.tag.is-light
              | E
            | &nbsp
            span.tag.is-info
              | T
      tbody
        tr(v-for="(data, index) in consumibles" :key="data.id")
          td
            span.tag
              | {{ data.fechaReg}} 
          td
            span
              | {{ data.origen_nombre }} / {{ data.destino_ubicacion }} {{ data.destino_nombre }}
          td
            b
              small 
                | Entrega:&nbsp
            span.tag.is-info {{ data.entrega }}
            | &nbsp
            a.button.is-small.is-rounded(:class="data.firma_entrega === '' ? 'is-text': 'is-black'" @click="firmarSalida(data, 1)")
              i.fas.fa-signature
            br
            b
              small
                | Traslada:&nbsp
            span.tag.is-primary {{ data.traslada }}
            | &nbsp
            a.button.is-small.is-rounded(:class="data.firma_traslada === ''? 'is-text': 'is-black'" @click="firmarSalida(data, 2)")
              i.fas.fa-signature
            br
            b
              small
                | Recibe:&nbsp
            span.tag.is-black {{ data.recibe }}
            | &nbsp
            a.button.is-small.is-rounded(:class="data.firma_recibe === ''? 'is-text': 'is-black'" @click="firmarSalida(data,3)")
              i.fas.fa-signature
          td 
            span.tag.is-light
              | {{ data.cantidad_e }}&nbsp
            | &nbsp
            span.tag.is-info
              | {{ data.cantidad_t }}&nbsp
</template>

<script>
  export default {
    name: 'TbConsumiblesTras',
    props: {
      consumibles: {
        type: Array,
        default: []
      },
    },
    methods: {
      firmarSalida (data, momento) {
        if (this.permisos.inventarios == 6) {
          return
        }
        let myObj = this.agregarMomento(data, momento)
        this.$emit('firmarSalida', myObj)
      },
      agregarMomento(data, momento) {
        return {
          ...data,
          estado: momento
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/TbConsumiblesTraslado.vue